import React, { useRef, useState } from 'react';
import { TextField } from '@mui/material';
import { DateTime } from 'luxon';
import Modal from 'bootstrap/js/dist/modal';

import { AddIcon } from '../../../icons';

const AddSaleTargetButton = ({ onAdd, targetDates }) => {
    const modalRef = useRef(null);
    const openButtonRef = useRef(null);
    const [tgtDate, setTgtDate] = useState();
    const [error, setError] = useState();

    const isValidNewDate = () => {
        const inputDt = DateTime.fromISO(tgtDate, {
            zone: 'America/Los_Angeles',
        }).startOf('day');
        const existingDays = new Set(
            targetDates.map((d) =>
                DateTime.fromJSDate(d, { zone: 'America/Los_Angeles' }).toISODate()
            )
        );
        if (existingDays.has(inputDt.toISODate())) {
            setError('Duplicate date. Target dates must be unique.');
            return false;
        }
        return true;
    };

    const handleOpen = () => {
        const modal = new Modal(modalRef.current);
        modal.show();
    };

    const handleDateChange = (e) => {
        setError('');
        setTgtDate(e.target.value);
    };

    const handleClose = () => {
        const modal = Modal.getInstance(modalRef.current);
        document.activeElement?.blur();
        modal?.hide();
        if (openButtonRef.current) {
            openButtonRef.current.focus();
        }
    };

    const handleAdd = () => {
        if (isValidNewDate()) {
            onAdd(tgtDate);
            handleClose();
        }
    };

    return (
        <>
            <button
                ref={openButtonRef}
                type="button"
                className="btn py-1 px-1 me-1 mb-1 lh-1 fw-bold acquisitions-add-target-button"
                onClick={handleOpen}
                title="Add Sale Target Date"
            >
        Add Target Date
                <AddIcon color="white" />
            </button>

            <div
                className="modal fade"
                tabIndex="-1"
                aria-hidden="true"
                ref={modalRef}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addSaleTargetLabel">
                Add Sale Target Date
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        {error && <p className="ps-3 text-danger">{error}</p>}
                        <div className="modal-body text-center">
                            <TextField
                                type="date"
                                value={tgtDate ?? ''}
                                onChange={handleDateChange}
                                variant="standard"
                                sx={{
                                    height: '100%',
                                    '& .MuiInputBase-root': {
                                        height: '100%',
                                        alignItems: 'center',
                                        padding: 0,
                                    },
                                    '& .MuiInputBase-input': {
                                        height: '100%',
                                        padding: '0 12px 0 0',
                                        boxSizing: 'border-box',
                                    },
                                }}
                                autoFocus
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={error || !tgtDate}
                                onClick={handleAdd}
                            >
                Add Date
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddSaleTargetButton;
